// Utils & misc
import cn from '../../../utils/cn';

// Components
import MenuNavigationButton from '../MenuNavigationButton/MenuNavigationButton';
import Picto from '../../atoms/Picto/Picto';

// Style
import style from './NavigationAccordionItem.module.css';

/**
 * NavigationAccordionItem component - Sidebar root item expanding its children inline.
 * @param {object} params
 * @param {string} params.id - Id of the item
 * @param {string} params.label - Item label
 * @param {string | null} [params.icon=null] - FontAwesome icon class
 * @param {string} [params.href] - Href when the item has no children
 * @param {boolean} [params.isExpanded=false] - Whether children are displayed
 * @param {boolean} [params.isMenuOpen=false] - Whether the menu is open
 * @param {() => void} params.onClick - Click handler (toggle or navigate)
 * @param {React.ReactNode} [params.children] - Expanded content (sub items)
 * @returns {JSX.Element} NavigationAccordionItem component
 */
function NavigationAccordionItem({
  id,
  label,
  icon = null,
  href,
  isExpanded = false,
  isMenuOpen = false,
  onClick,
  children = null,
}) {
  const hasChildren = Boolean(children);
  const showChildren = hasChildren && isExpanded && isMenuOpen;

  return (
    <div className={style['accordion-item']}>
      <MenuNavigationButton
        id={`${id}-button`}
        icon={icon}
        label={label}
        href={href}
        onClick={onClick}
        isMenuOpen={isMenuOpen}
      >
        {hasChildren && isMenuOpen ? (
          <Picto
            icon="arrow-down"
            className={cn([style.chevron, showChildren && style['chevron-up']])}
          />
        ) : null}
      </MenuNavigationButton>

      {showChildren ? (
        <div id={`${id}-children`} className={style.children}>
          {children}
        </div>
      ) : null}
    </div>
  );
}

export default NavigationAccordionItem;
